import * as React from "react";
import {useNavigate} from "react-router-dom";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Helmet} from "react-helmet";
import Badge from "react-bootstrap/Badge";
import API from "../../api";
import {useEffect, useState} from "react";
import moment from "moment";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


function Plans() {
	let navigate = useNavigate();

	const [plans, setPlans] = useState([])
	const [isLoading, setLoading] = useState(false)

	useEffect(() => {
		setLoading(true);
		API.get("admin/plan")
			.then(response => setPlans(response.data))
			.finally(() => setLoading(false));
	}, [])

	const onRowSelect = (event) => {
		navigate(`/admin/plan/${event.data.id}`)
	};

	const createdDateTemplate = (plan) => {
		return moment(plan.created_at).format('YYYY-MM-DD');
	}

	return (
		<>
			<Helmet>
				<title>Plans | MyGolfDNA.com</title>
				<meta name="description" content="Plans"/>
			</Helmet>
			<div className="mt-4">
				<Row>
					<Col>
						<h2>Categories</h2>
						<div className="card">
							<DataTable
								value={plans}
								paginator rows={10}
								rowsPerPageOptions={[10, 25, 50]}
								tableStyle={{ minWidth: '50rem' }}
								selectionMode="single"
								onRowSelect={onRowSelect}
								sortField="created_at"
								sortOrder={-1}
							>
								<Column field="planName" sortable header="Plan Name"/>
								<Column field="instructor.firstName" sortable header="Instructor"/>
								<Column field="amount" sortable header="Amount"/>
								<Column field="lessonCount" sortable header="Lesson Count"/>
								<Column field="active" sortable header="Active"/>
								<Column field="visible" sortable header="Visible"/>
								<Column field="created_at" sortable header="Created Date" body={createdDateTemplate}/>
							</DataTable>
						</div>
					</Col>
				</Row>
			</div>
		</>
	);
}

export default Plans;
